import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'xs-lib-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.css']
})
export class MessageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
